import Mixpanel from "../utils/mixpanel";
import { getSessionId } from "../utils/session.js";

const sessionId = getSessionId();

export const tracker = {
  login: {
    formSubmit: (email) => {
      Mixpanel.track(`submit:login-credential`, {
        message: `Get login credential form submitted successfully.`,
        email,
      });
    },

    pageView: () => {
      Mixpanel.track(`page:login`, {
        message: `Visited inception login page.`,
        session_id: sessionId,
      });
    },
  },
  logout: {
    onClick: () => {
      Mixpanel.track(`click:logout`, {
        message: `Clicked logout button.`,
        session_id: sessionId,
      });
    },
  },
  forgotPassword: {
    onClick: () => {
      Mixpanel.track(`click:forgot-password`, {
        message: `Clicked forgot password link.`,
        session_id: sessionId,
      });
    },
    formSubmit: (email) => {
      Mixpanel.track(`submit:forgot-password`, {
        message: `Get forgot password form submitted successfully.`,
        email,
      });
    },
    pageView: () => {
      Mixpanel.track(`page:forgot-password`, {
        message: `Visited inception forgot password page.`,
        session_id: sessionId,
      });
    },
  },
  dashboard: {
    pageView: () => {
      Mixpanel.track(`page:dashboard`, {
        message: `Visited inception dashboard page.`,
        session_id: sessionId,
      });
    },
  },
  subAdmin: {
    pageView: () => {
      Mixpanel.track(`page:sub-admin`, {
        message: `Visited inception sub-admin page.`,
        session_id: sessionId,
      });
    },
    addSubAdmin: () => {
      Mixpanel.track(`click:add-sub-admin`, {
        message: `Click on  add sub-admin button.`,
        session_id: sessionId,
      });
    },
    addFormSubmitted: () => {
      Mixpanel.track(`form-submitted:add-sub-admin`, {
        message: `Form submitted for add sub-admin.`,
        session_id: sessionId,
      });
    },
    addFormCancelled: () => {
      Mixpanel.track(`form-cancelled:add-sub-admin`, {
        message: `Form cancelled for add sub-admin.`,
        session_id: sessionId,
      });
    },
    editSubAdmin: () => {
      Mixpanel.track(`click:edit-sub-admin`, {
        message: `Click on  edit sub-admin button.`,
        session_id: sessionId,
      });
    },
    editFormSubmitted: (email) => {
      Mixpanel.track(`form-submitted:edit-sub-admin`, {
        message: `Form submitted for edit sub-admin.`,
        session_id: sessionId,
        email: email ?? "",
      });
    },
    editFormCancelled: () => {
      Mixpanel.track(`form-cancelled:edit-sub-admin`, {
        message: `Form cancelled for edit sub-admin.`,
        session_id: sessionId,
      });
    },
    deleteSubAdmin: () => {
      Mixpanel.track(`click:delete-sub-admin`, {
        message: `Click on  delete sub-admin button.`,
        session_id: sessionId,
      });
    },
  },
  customiZation: {
    pageView: () => {
      Mixpanel.track(`page:customization`, {
        message: `Visited inception customization page.`,
        session_id: sessionId,
      });
    },
    applyChangesClicked: () => {
      Mixpanel.track(`click:apply-changes`, {
        message: `Click on  apply changes button.`,
        session_id: sessionId,
      });
    },
    resetChangesClicked: () => {
      Mixpanel.track(`click:reset-changes`, {
        message: `Click on  reset changes button.`,
        session_id: sessionId,
      });
    },
  },
  trancheBot: {
    pageView: () => {
      Mixpanel.track(`page:tranche-bot`, {
        message: `Visited tranche bot page.`,
        session_id: sessionId,
      });
    },
    opportunityIdSubmitted: (id) => {
      Mixpanel.track(`form-submitted:tranche-bot-opportunity-id`, {
        message: `Opportunity id submitted in tranche bot.`,
        session_id: sessionId,
        opportunityId: id,
      });
    },
    trancheFormSubmitted: (id) => {
      Mixpanel.track(`form-submitted:tranche-bot`, {
        message: `Form submitted in tranche bot.`,
        session_id: sessionId,
        opportunityId: id,
      });
    },
  },
  accessControl: {
    pageView: () => {
      Mixpanel.track(`page:access-control`, {
        message: `Visited access control page.`,
        session_id: sessionId,
      });
    },
    disabledAPIKeyClicked: () => {
      Mixpanel.track(`click:disabled-api-key`, {
        message: `Click on  disabled api key button in access control.`,
        session_id: sessionId,
      });
    },
    addTaskClicked: (email) => {
      Mixpanel.track(`click:add-task`, {
        message: `Click on  add task button for sub-admin.`,
        session_id: sessionId,
        subAdmin: email,
      });
    },
    addArchiveTaskClicked: (email) => {
      Mixpanel.track(`click:add-archive-task`, {
        message: `Click on  add archive task button for sub-admin.`,
        session_id: sessionId,
        subAdmin: email,
      });
    },
    addTaskFormSubmitted: (email) => {
      Mixpanel.track(`form-submitted:add-task`, {
        message: `Form submitted for add task for a sub-admin.`,
        session_id: sessionId,
        subAdmin: email,
      });
    },
    addArchiveTaskFormSubmitted: (email) => {
      Mixpanel.track(`form-submitted:add-archive-task`, {
        message: `Form submitted for add archive task for a sub-admin.`,
        session_id: sessionId,
        subAdmin: email,
      });
    },
    createApiKeyClicked: () => {
      Mixpanel.track(`click:create-api-key`, {
        message: `Click on  create api key button in access control.`,
        session_id: sessionId,
      });
    },
    createApiKeyFormSubmitted: () => {
      Mixpanel.track(`form-submitted:create-api-key`, {
        message: `Form submitted for create api key in access control.`,
        session_id: sessionId,
      });
    },
    deleteApiKey: () => {
      Mixpanel.track(`click:delete-api-key`, {
        message: `Click on  delete api key button in access control.`,
        session_id: sessionId,
      });
    },
    updateApiKey: () => {
      Mixpanel.track(`click:update-api-key`, {
        message: `Click on  update api key button in access control.`,
        session_id: sessionId,
      });
    },
    resetApiKey: () => {
      Mixpanel.track(`click:reset-api-key`, {
        message: `Click on  reset api key button in access control.`,
        session_id: sessionId,
      });
    },
    deleteApiKey: () => {
      Mixpanel.track(`click:de-active-api-key`, {
        message: `Click on  de-active api key button in access control.`,
        session_id: sessionId,
      });
    },
    permissionClicked: (perm) => {
      Mixpanel.track(`click:permission-toggle`, {
        message: `Click on permission toggle in access control.`,
        session_id: sessionId,
        permission: perm,
      });
    },
  },
  reportsCenter: {
    pageView: () => {
      Mixpanel.track(`page:reports-center`, {
        message: `Visited reports center page.`,
        session_id: sessionId,
      });
    },
    emailAdd: (email) => {
      Mixpanel.track(`click:email-add`, {
        message: `Click on  email add button in reports center.`,
        session_id: sessionId,
        email: email,
      });
    },
    emailRemove: (email) => {
      Mixpanel.track(`click:email-remove`, {
        message: `Click on  email remove button in reports center.`,
        session_id: sessionId,
        email: email,
      });
    },
    fileDownload: (link) => {
      Mixpanel.track(`click:file-download`, {
        message: `Click on  file download button in reports center.`,
        session_id: sessionId,
        link: link,
      });
    },
    reportExport: (reportName) => {
      Mixpanel.track(`click:report-export`, {
        message: `Click on export report button in reports center.`,
        session_id: sessionId,
        reportName: reportName,
      });
    },
  },
  contacts: {
    pageView: () => {
      Mixpanel.track(`page:contacts`, {
        message: `Visited contacts page.`,
        session_id: sessionId,
      });
    },
    clickOnContactSectionClick: () => {
      Mixpanel.track(`click:contact-section`, {
        message: `Click on button contact document section in contacts page.`,
        session_id: sessionId,
      });
    },
    contactSearch: (searchTerm) => {
      Mixpanel.track(`search:contact-search`, {
        message: `Search contact in contacts page.`,
        session_id: sessionId,
        searchTerm: searchTerm,
      });
    },
    clickOnEditDocumentSection: () => {
      Mixpanel.track(`click:edit-document-section`, {
        message: `Click on button edit document section in contacts page.`,
        session_id: sessionId,
      });
    },
    clickOnDeleteDocumentSection: () => {
      Mixpanel.track(`click:delete-document-section`, {
        message: `Click on button delete document section in contacts page.`,
        session_id: sessionId,
      });
    },
    editedDocumentSection: (prevSectionName, newSectionName) => {
      Mixpanel.track(`form-submit:edited-document-section`, {
        message: `Form submitted for edit document section in contacts page.`,
        session_id: sessionId,
        prevSectionName: prevSectionName,
        newSectionName: newSectionName,
      });
    },
    deletedDocumentSection: (sectionName) => {
      Mixpanel.track(`form-submit:deleted-document-section`, {
        message: `Form submitted for delete document section in contacts page.`,
        session_id: sessionId,
        sectionName: sectionName,
      });
    },
    clickOnCreateDocumentSection: () => {
      Mixpanel.track(`click:create-document-section`, {
        message: `Click on button for create document section in contacts page.`,
        session_id: sessionId,
      });
    },
    createdDocumentSection: (sectionName) => {
      Mixpanel.track(`form-submit:created-document-section`, {
        message: `Form submitted for create document section in contacts page.`,
        session_id: sessionId,
        sectionName: sectionName,
      });
    },
    clickOnContactDocument: (userId) => {
      Mixpanel.track(`click:contact-document`, {
        message: `Click on action of contact document in contacts page for a contact.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    clickOnAddRecord: (userId) => {
      Mixpanel.track(`click:add-record`, {
        message: `Click on button add record for a contact in contacts page.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    clickOnReplaceDocument: (userId) => {
      Mixpanel.track(`click:replace-document`, {
        message: `Click on button replace document for a contact in contacts page.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    clickOnDeleteRecord: (userId) => {
      Mixpanel.track(`click:delete-record`, {
        message: `Click on button delete record for a contact in contacts page.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    deletedContactRecord: (userId) => {
      Mixpanel.track(`form-submit:deleted-contact-record`, {
        message: `Form submitted for delete record for a contact in contacts page.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    clickOnHistoryForRecord: (userId) => {
      Mixpanel.track(`click:history-for-record`, {
        message: `Click on  history icon for record for a contact in contacts page.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    addedNewRecord: (userId) => {
      Mixpanel.track(`form-submit:added-new-record`, {
        message: `Form submitted for add new record for a contact in contacts page.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    updatedRecordFile: (userId) => {
      Mixpanel.track(`form-submit:updated-record-file`, {
        message: `Form submitted for update record file for a contact in contacts page.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    clickOnFileDownload: (userId) => {
      Mixpanel.track(`click:file-download`, {
        message: `Click on button file download for a contact in contacts page.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    clickOnValidatedCheck: (userId, isAI) => {
      Mixpanel.track(`click:manual-validated`, {
        message: isAI
          ? `Click on checkbox AI validated for a contact in contacts page.`
          : `Click on checkbox manual validated for a contact in contacts page.`,
        session_id: sessionId,
        userId: userId,
      });
    },
    exportContactsClick: () => {
      Mixpanel.track(`click:export-contacts`, {
        message: `Click on button export contacts in contacts page.`,
        session_id: sessionId,
      });
    },
  },
  tsaBilling: {
    pageView: () => {
      Mixpanel.track(`page:tsa-billing`, {
        message: `Visited tsa billing page.`,
        session_id: sessionId,
      });
    },
    clickOnExportXls: () => {
      Mixpanel.track(`click:export-xlsv`, {
        message: `Click on button export xlsv in tsa billing page.`,
        session_id: sessionId,
      });
    },
    tsaBillingRecordSearch: (searchText) => {
      Mixpanel.track(`form-submit:tsa-billing-record-search`, {
        message: `Form submitted for tsa billing record search in tsa billing page.`,
        session_id: sessionId,
        searchText: searchText,
      });
    },
  },
  userJourney: {
    pageView: () => {
      Mixpanel.track(`page:user-journey`, {
        message: `Visited user journey page.`,
        session_id: sessionId,
      });
    },
    clickOnContactGroupSelection: () => {
      Mixpanel.track(`click:contact-group-selection`, {
        message: `Click on button contact group selection in user journey page.`,
        session_id: sessionId,
      });
    },
    clickOnCheckbox: (contactGroup, role) => {
      Mixpanel.track(`click:checkbox`, {
        message: `Click on checkbox in user journey page for contact ${contactGroup} and role ${role}.`,
        session_id: sessionId,
      });
    },
  },
  productionReporting: {
    pageView: () => {
      Mixpanel.track(`page:production-reporting`, {
        message: `Visited production reporting page.`,
        session_id: sessionId,
      });
    },
    productionReportingSearch: (searchTerm) => {
      Mixpanel.track("search:production-reporting", {
        message: "Searched the list on 'Production Reporting' page.",
        session_id: sessionId,
        searchTerm,
      });
    },
    clickOnExportButton: () => {
      Mixpanel.track(`click:export-button`, {
        message: `Click on button export in production reporting page.`,
        session_id: sessionId,
      });
    },
    clickOnUploadButton: () => {
      Mixpanel.track(`click:upload-button`, {
        message: `Click on button upload in production reporting page.`,
        session_id: sessionId,
      });
    },
    clickOnSpecialUploadButton: () => {
      Mixpanel.track(`click:special-upload-button`, {
        message: `Click on button special upload in production reporting page.`,
        session_id: sessionId,
      });
    },
    clickOnDeleteIcon: () => {
      Mixpanel.track(`click:delete-icon`, {
        message: `Click on delete icon in production reporting page.`,
        session_id: sessionId,
      });
    },
    clickOnEditIcon: () => {
      Mixpanel.track(`click:edit-icon`, {
        message: `Click on edit icon in production reporting page.`,
        session_id: sessionId,
      });
    },
    editedProductionReport: (id) => {
      Mixpanel.track(`form-submit:edited-production-report`, {
        message: `Form submitted for edit production report in production reporting page.`,
        session_id: sessionId,
        recordId: id,
      });
    },
    deletedProductionReport: (id) => {
      Mixpanel.track(`form-submit:deleted-production-report`, {
        message: `Form submitted for delete production report in production reporting page.`,
        session_id: sessionId,
        recordId: id,
      });
    },
    fileUpload: () => {
      Mixpanel.track(`file-upload:production-report`, {
        message: `File uploaded in production reporting page.`,
        session_id: sessionId,
      });
    },
    specialFileUpload: () => {
      Mixpanel.track(`special-upload:production-report`, {
        message: `Special file uploaded in production reporting page.`,
        session_id: sessionId,
      });
    },
    clickOnBulkProductionReportButton: () => {
      Mixpanel.track(`click:bulk-production-report-button`, {
        message: `Click on button bulk production report in production reporting page.`,
        session_id: sessionId,
      });
    },
    clickOnBulkProductionReportButtonV2: () => {
      Mixpanel.track(`click:bulk-production-report-button-v2`, {
        message: `Click on button bulk production report in production reporting v2 page.`,
        session_id: sessionId,
      });
    },
    bulkProductionReportGenerated: (monthYear) => {
      Mixpanel.track(`submit:bulk-production-report`, {
        message: `Bulk production report generation initiated.`,
        session_id: sessionId,
        monthYear,
      });
    },
    bulkProductionReportGeneratedV2: (monthYear) => {
      Mixpanel.track(`submit:bulk-production-report-v2`, {
        message: `Bulk production report generation initiated in production reporting v2 page.`,
        session_id: sessionId,
        monthYear,
      });
    },
  },
  assetLogs: {
    pageView: () => {
      Mixpanel.track(`page:asset-logs`, {
        message: `Visited asset logs page.`,
        session_id: sessionId,
      });
    },
    uploadedFileDownload: (fileName) => {
      Mixpanel.track(`file-download:asset-logs`, {
        message: "Uploaded file downloaded in asset logs page.",
        session_id: sessionId,
        fileName: fileName,
      });
    },
    errorFileDownload: (fileName) => {
      Mixpanel.track(`file-download:asset-logs`, {
        message: "Error file downloaded in asset logs page.",
        session_id: sessionId,
        fileName: fileName,
      });
    },

    assetLogEmail: {
      clickOnAddNewEmail: () => {
        Mixpanel.track(`click:add-new-email`, {
          message: `Click on button add new email in asset logs page.`,
          session_id: sessionId,
        });
      },
      emailAdd: (email) => {
        Mixpanel.track(`click:email-add`, {
          message: `Click on  email add button in asset logs page.`,
          session_id: sessionId,
          email: email,
        });
      },
      clickOnEmailRemove: (email) => {
        Mixpanel.track(`click:email-remove`, {
          message: `Click on  email remove button in asset logs page.`,
          session_id: sessionId,
          email: email,
        });
      },
      clickOnEmailEdit: (email) => {
        Mixpanel.track(`click:email-edit`, {
          message: `Click on  email edit button in asset logs page.`,
          session_id: sessionId,
          email: email,
        });
      },
      emailRemove: (email) => {
        Mixpanel.track(`click:email-remove`, {
          message: `Click on  email remove button in asset logs page.`,
          session_id: sessionId,
          email: email,
        });
      },
      editEmail: (email) => {
        Mixpanel.track(`click:email-edit`, {
          message: `Click on  email edit button in asset logs page.`,
          session_id: sessionId,
          email: email,
        });
      },
    },

    assetHistory: {
      assetSearch: (searchTerm) => {
        Mixpanel.track(`click:asset-search`, {
          message: `Click on  asset search button in asset logs page.`,
          session_id: sessionId,
          searchTerm: searchTerm,
        });
      },
    },
    syncLogs: {
      clickOnAllAssets: (title) => {
        Mixpanel.track(`click:all-assets`, {
          message: `Click on  all assets button in asset logs page.`,
          session_id: sessionId,
          title: title,
        });
      },
      clickOnFailedAssets: (title) => {
        Mixpanel.track(`click:failed-assets`, {
          message: `Click on  failed assets button in asset logs page.`,
          session_id: sessionId,
          title: title,
        });
      },
    },
  },
  assetV2Events: {
    pageView: () => {
      Mixpanel.track(`page:asset-v2`, {
        message: `Visited asset v2 page.`,
        session_id: sessionId,
      });
    },
    rejectCriticalAssets: () => {
      Mixpanel.track("click:reject-critical-assets", {
        message: "Clicked 'Reject Critical Assets' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    generateTSABillingReport: () => {
      Mixpanel.track("click:generate-tsa-billing-report", {
        message:
          "Clicked 'Generate TSA Billing Report' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    updateAssetRow: (assetId) => {
      Mixpanel.track("click:update-asset-row", {
        message:
          "Clicked 'Update' button for an asset row on 'Assets v2' page.",
        session_id: sessionId,
        assetId,
      });
    },
    deleteAssetRow: (assetId) => {
      Mixpanel.track("click:delete-asset-row", {
        message:
          "Clicked 'Delete' button for an asset row on 'Assets v2' page.",
        session_id: sessionId,
        assetId,
      });
    },
    assetV2Search: (searchTerm) => {
      Mixpanel.track("search:asset-v2", {
        message: "Searched the list on 'Assets v2' page.",
        session_id: sessionId,
        searchTerm,
      });
    },
    assetFlagsClick: () => {
      Mixpanel.track("click:asset-flags", {
        message: "Clicked 'Asset Flags' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    uploadAssetsClick: () => {
      Mixpanel.track("click:upload-assets", {
        message: "Clicked 'Upload' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    uploadAssetsSubmit: () => {
      Mixpanel.track("submit:upload-assets", {
        message: "Submitted file upload on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    exportAssetsClick: () => {
      Mixpanel.track("click:export-assets", {
        message: "Clicked 'Export' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    exportTemplateVersion: () => {
      Mixpanel.track("click:export-template-version", {
        message: "Clicked 'Template Version' of export on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    exportFullVersion: () => {
      Mixpanel.track("click:export-full-version", {
        message: "Clicked 'Full Version' of export on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    manageColumnsClick: () => {
      Mixpanel.track("click:asset-columns", {
        message: "Clicked 'Manage Columns' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    addNewColumn: () => {
      Mixpanel.track("click:add-new-column", {
        message: "Clicked 'Add New Column' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    saveUpdateColumn: () => {
      Mixpanel.track("click:save-update-column", {
        message: "Clicked 'Save & Update Column' on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    deleteColumn: () => {
      Mixpanel.track("click:delete-column", {
        message: "Clicked 'Delete Column' on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    manageDocumentsClick: () => {
      Mixpanel.track("click:asset-manage-document", {
        message: "Clicked 'Manage Document' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetFlagsClick: () => {
      Mixpanel.track("click:asset-flags", {
        message: "Clicked 'Asset Flags' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    assetFlagToggleConfirmModal: () => {
      Mixpanel.track("click:asset-flag-toggle-confirmation-modal", {
        message:
          "Toggled confirmation modal in Asset Flags section on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    startAssetSync: () => {
      Mixpanel.track("click:asset-sync-start", {
        message: "Clicked 'Start Syncing' to sync assets on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    productionReportSync: () => {
      Mixpanel.track("click:asset-production-report-sync", {
        message:
          "Clicked 'Production Report Generation' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    acceptCriticalAssets: () => {
      Mixpanel.track("click:accept-critical-assets", {
        message: "Accepted critical asset(s) on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    deleteCriticalAssets: () => {
      Mixpanel.track("click:delete-critical-assets", {
        message: "Deleted critical asset(s) on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    markAsAccepted: () => {
      Mixpanel.track("click:mark-as-accepted", {
        message: "Marked asset(s) as accepted on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    replacementStatusUpdate: () => {
      Mixpanel.track("click:replacement-status-update", {
        message:
          "Updated replacement status for selected asset(s) on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    openExportModal: () => {
      Mixpanel.track("open:asset-export-modal", {
        message: "Opened 'Export Assets' modal on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    expandApiDetails: () => {
      Mixpanel.track("expand:asset-column-api-details", {
        message:
          "Expanded API details in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    collapseApiDetails: () => {
      Mixpanel.track("collapse:asset-column-api-details", {
        message:
          "Collapsed API details in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    apiAddNewClick: () => {
      Mixpanel.track("click:asset-column-api-add-new", {
        message:
          "Clicked 'Add API' button in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    apiAddSubmit: () => {
      Mixpanel.track("click:asset-column-api-add-submit", {
        message:
          "Submitted 'Add API' form in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    apiEditClick: (name) => {
      Mixpanel.track("click:asset-column-api-edit", {
        message:
          "Clicked 'Edit Icon' in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
        api_name: name,
      });
    },

    apiEditSubmit: (apiName) => {
      Mixpanel.track("click:asset-column-api-edit-submit", {
        message:
          "Submitted 'Edit API' form in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
        api_name: apiName,
      });
    },

    apiDeleteClick: (id, name) => {
      Mixpanel.track("click:asset-column-api-delete", {
        message:
          "Clicked 'Delete Icon' in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
        api_id: id,
        api_name: name,
      });
    },

    apiDeleteConfirm: (id) => {
      Mixpanel.track("click:asset-column-api-delete-confirm", {
        message:
          "Confirmed API deletion in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
        api_id: id,
      });
    },

    apiDetailsView: (name) => {
      Mixpanel.track("click:asset-column-api-details", {
        message:
          "Viewed API details in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
        api_name: name,
      });
    },
    assetRowMarkAsAccepted: () => {
      Mixpanel.track("click:asset-row-mark-as-accepted", {
        message: "Marked asset row as accepted on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    viewAssetHistory: (assetId) => {
      Mixpanel.track("click:asset-row-view-history", {
        message: "Viewed asset history on 'Assets v2' page.",
        session_id: sessionId,
        asset_id: assetId,
      });
    },
    clearZohoFields: (assetId) => {
      Mixpanel.track("click:asset-row-clear-zoho-fields", {
        message: "Cleared Zoho fields on 'Assets v2' page.",
        session_id: sessionId,
        asset_id: assetId,
      });
    },
    viewAssetDocuments: (assetId) => {
      Mixpanel.track("click:asset-row-view-documents", {
        message: "Viewed asset documents on 'Assets v2' page.",
        session_id: sessionId,
        asset_id: assetId,
      });
    },
    uploadAssetDocuments: (assetId) => {
      Mixpanel.track("click:asset-row-upload-documents", {
        message: "Uploaded asset documents on 'Assets v2' page.",
        session_id: sessionId,
        asset_id: assetId,
      });
    },
    viewAssetDocumentHistory: () => {
      Mixpanel.track("click:asset-document-view-history", {
        message: "Viewed asset document history on 'Assets v2' page.",
        session_id: sessionId,
      });
    },
    assetRepullAPIcall: (assetId) => {
      Mixpanel.track("click:asset-repull-api-call", {
        message: "Repulled API call for asset on 'Assets v2' page.",
        session_id: sessionId,
        asset_id: assetId,
      });
    },
    uccDataPush: (assetId) => {
      Mixpanel.track("click:asset-ucc-data-push", {
        message: "Pushed UCC data for asset on 'Assets v2' page.",
        session_id: sessionId,
        asset_id: assetId,
      });
    },
    assetRequestCorrection: (assetId) => {
      Mixpanel.track("click:asset-request-correction", {
        message: "Requested correction for asset on 'Assets v2' page.",
        session_id: sessionId,
        asset_id: assetId,
      });
    },
    requestCorrectionSave: (assetId) => {
      Mixpanel.track("click:asset-request-correction-save", {
        message: "Saved correction request for asset on 'Assets v2' page.",
        session_id: sessionId,
        asset_id: assetId,
      });
    },
    deleteAssetDocument: (assetId, documentId) => {
      Mixpanel.track("click:asset-document-delete", {
        message: "Deleted asset document on 'Assets v2' page.",
        session_id: sessionId,
        asset_id: assetId,
        document_id: documentId,
      });
    },

    expandApiDetails: () => {
      Mixpanel.track("expand:asset-column-api-details", {
        message:
          "Expanded API details in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    collapseApiDetails: () => {
      Mixpanel.track("collapse:asset-column-api-details", {
        message:
          "Collapsed API details in Asset Column API Management on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetColumnSaveOrUpdateClick: (isNew) => {
      Mixpanel.track(
        isNew ? "click:asset-column-save" : "click:asset-column-update",
        {
          message: isNew
            ? "Clicked 'Create New Column' button on 'Assets v2' page."
            : "Clicked 'Update Column' button on 'Assets v2' page.",
          session_id: sessionId,
        }
      );
    },

    assetColumnAddNewClick: () => {
      Mixpanel.track("click:asset-column-add-new", {
        message: "Clicked 'Add New Column' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetColumnApiModalOpen: () => {
      Mixpanel.track("click:asset-column-api-modal-open", {
        message:
          "Opened 'Asset Column API Management' modal on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetColumnDeleteClick: (columnId) => {
      Mixpanel.track("click:asset-column-delete", {
        message: "Clicked 'Delete Column' button on 'Assets v2' page.",
        session_id: sessionId,
        column_id: columnId,
      });
    },

    assetColumnReorder: (label) => {
      Mixpanel.track("drag:asset-column", {
        message: "Dragged an Asset column on 'Assets v2' page.",
        session_id: sessionId,
        label: label,
      });
    },

    assetDocumentAddNewColumnClick: (sectionId) => {
      Mixpanel.track("click:asset-document-add-new-column", {
        message:
          "Clicked 'Add New Column' button in Asset Document Section on 'Assets v2' page.",
        session_id: sessionId,
        section_id: sectionId,
      });
    },

    assetDocumentColumnDeleteClick: (columnId, sectionId) => {
      Mixpanel.track("click:asset-document-column-delete", {
        message:
          "Clicked 'Delete Icon' in Asset Document Section on 'Assets v2' page.",
        session_id: sessionId,
        column_id: columnId,
        section_id: sectionId,
      });
    },

    assetDocumentColumnDeleteConfirm: (columnId, sectionId) => {
      Mixpanel.track("click:asset-document-column-delete-confirm", {
        message:
          "Clicked 'Confirm Delete' in delete confirmation modal in Asset Document Section on 'Assets v2' page.",
        session_id: sessionId,
        column_id: columnId,
        section_id: sectionId,
      });
    },

    assetDocumentColumnSave: (sectionId) => {
      Mixpanel.track("click:asset-document-column-save", {
        message: "Saved column in Asset Document Section on 'Assets v2' page.",
        session_id: sessionId,
        section_id: sectionId,
      });
    },

    assetDocumentSectionCreateClick: () => {
      Mixpanel.track("click:asset-document-section-create", {
        message: "Clicked 'Create Section' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetDocumentSectionEditClick: (sectionName) => {
      Mixpanel.track("click:asset-document-section-edit", {
        message: "Clicked 'Edit Section' button on 'Assets v2' page.",
        session_id: sessionId,
        section_name: sectionName,
      });
    },

    assetDocumentSectionDeleteClick: (sectionId) => {
      Mixpanel.track("click:asset-document-section-delete", {
        message: "Clicked 'Delete Section' button on 'Assets v2' page.",
        session_id: sessionId,
        section_id: sectionId,
      });
    },

    assetDocumentSectionDeleteConfirmClick: (sectionId) => {
      Mixpanel.track("click:asset-document-section-delete-confirm", {
        message:
          "Clicked 'Confirm Delete' in delete confirmation modal on 'Assets v2' page.",
        session_id: sessionId,
        section_id: sectionId,
      });
    },

    assetDocumentSectionApiManagementClick: () => {
      Mixpanel.track("click:asset-document-section-api-management", {
        message:
          "Clicked 'API Management' in Asset Document Section on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetDocumentSectionEditSaveClick: (sectionName) => {
      Mixpanel.track("click:asset-document-section-edit-save", {
        message:
          "Clicked 'Save' button to edit an Asset Document Section on 'Assets v2' page.",
        session_id: sessionId,
        section_name: sectionName,
      });
    },

    assetDocumentSectionCreateSaveClick: (sectionName) => {
      Mixpanel.track("click:asset-document-section-create-save", {
        message:
          "Clicked 'Save' button to create a new Asset Document Section on 'Assets v2' page.",
        session_id: sessionId,
        section_name: sectionName,
      });
    },

    assetDocumentExportClick: () => {
      Mixpanel.track("click:asset-document-export", {
        message: "Clicked 'Export Document Data' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetDocumentApiAddClick: () => {
      Mixpanel.track("click:asset-document-api-add", {
        message: "Clicked 'Add API' button on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetDocumentApiEditClick: (apiName) => {
      Mixpanel.track("click:asset-document-api-edit", {
        message: "Clicked 'Edit API' button on 'Assets v2' page.",
        session_id: sessionId,
        api_name: apiName,
      });
    },

    assetDocumentApiDeleteClick: (apiId) => {
      Mixpanel.track("click:asset-document-api-delete", {
        message: "Clicked 'Delete API' button on 'Assets v2' page.",
        session_id: sessionId,
        api_id: apiId,
      });
    },

    assetDocumentApiDeleteConfirm: (apiId) => {
      Mixpanel.track("click:asset-document-api-delete-confirm", {
        message:
          "Clicked 'Confirm Delete' in delete confirmation modal on 'Assets v2' page.",
        session_id: sessionId,
        api_id: apiId,
      });
    },

    assetDocumentApiAddSubmit: () => {
      Mixpanel.track("click:asset-document-api-add-submit", {
        message:
          "Clicked 'Submit' button in Add API modal on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetDocumentApiEditSubmit: (id) => {
      Mixpanel.track("click:asset-document-api-edit-submit", {
        message:
          "Clicked 'Submit' button in Edit API modal on 'Assets v2' page.",
        session_id: sessionId,
        api_id: id,
      });
    },

    assetFlagAddNewFlag: () => {
      Mixpanel.track("click:asset-flag-add-new-flag", {
        message:
          "Clicked 'Save' button in Asset Flags section on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetFlagAddNewFlagClick: () => {
      Mixpanel.track("click:asset-flag-add-new-flag", {
        message:
          "Clicked 'Add New Flag' button in Asset Flags section on 'Assets v2' page.",
        session_id: sessionId,
      });
    },

    assetFlagDeleteFlagConfirm: (flagId) => {
      Mixpanel.track("click:asset-flag-delete-flag-confirm", {
        message:
          "Clicked 'Confirm Delete' in delete confirmation modal in Asset Flags section on 'Assets v2' page.",
        flagId,
        session_id: sessionId,
      });
    },

    exportAssetsTemplateClick: () => {
      Mixpanel.track("click:export-assets-template", {
        message: "Clicked 'Template Version' export button.",
        session_id: sessionId,
      });
    },

    exportAssetsFullClick: () => {
      Mixpanel.track("click:export-assets-full", {
        message: "Clicked 'Full Version' export button.",
        session_id: sessionId,
      });
    },

    startProductionReportPdfSyncClick: (syncAll, asset) => {
      Mixpanel.track("click:start-production-report-pdf-sync", {
        message:
          "Clicked 'Start Sync' button in Production Report Pdf Sync modal on 'Assets v2' page.",
        syncAll,
        assetIdProvided: !!asset,
        session_id: sessionId,
      });
    },

    statusChangedFilter: (status) => {
      Mixpanel.track("filter-change:status-changed", {
        message: "Changed status filter on 'Assets v2' page.",
        status,
        session_id: sessionId,
      });
    },
    assetHistoryView: (assetId) => {
      Mixpanel.track(`click:asset-history-view`, {
        message: `Clicked 'View History' button in asset audit page.`,
        session_id: sessionId,
        assetId: assetId,
      });
    },
    productionReportFileView: (assetId) => {
      Mixpanel.track(`click:production-report-file-view`, {
        message: `Clicked 'View File' button in production report file modal.`,
        session_id: sessionId,
        assetId: assetId,
      });
    },
  },
  assetAudit: {
    pageView: () => {
      Mixpanel.track(`page:asset-audit`, {
        message: `Visited asset audit page.`,
        session_id: sessionId,
      });
    },
    assetAuditSearch: (searchTerm) => {
      Mixpanel.track("search:asset-audit", {
        message: "Searched the list on 'Asset Audit' page.",
        session_id: sessionId,
        searchTerm,
      });
    },
    statusFilterChange: (status) => {
      Mixpanel.track(`filter-change:status`, {
        message: `Asset audit status filter changed.`,
        session_id: sessionId,
        status: status,
      });
    },
    readyToAcceptClick: () => {
      Mixpanel.track(`click:ready-to-accept`, {
        message: `Clicked 'Ready to Accept' button in asset audit page.`,
        session_id: sessionId,
      });
    },
    rejectClick: (count) => {
      Mixpanel.track(`click:reject`, {
        message: `Clicked 'Reject' button in asset audit page.`,
        session_id: sessionId,
        rejectedAssetsCount: count,
      });
    },
    clearClick: (count) => {
      Mixpanel.track(`click:clear`, {
        message: `Clicked 'Clear' button in asset audit page.`,
        session_id: sessionId,
        clearedAssetsCount: count,
      });
    },
  },
  tranches: {
    pageView: () => {
      Mixpanel.track(`page:tranches`, {
        message: `Visited tranches page.`,
        session_id: sessionId,
      });
    },
    exportTranchesClick: () => {
      Mixpanel.track(`click:export-tranches`, {
        message: `Clicked 'Export Tranches' button in tranches page.`,
        session_id: sessionId,
      });
    },
    trancheApiAddClick: () => {
      Mixpanel.track(`click:api-management`, {
        message: `Clicked 'Api Management' button in tranches page.`,
        session_id: sessionId,
      });
    },
    tranchesSearch: (searchTerm) => {
      Mixpanel.track("search:tranches", {
        message: "Searched the list on 'Tranches' page.",
        session_id: sessionId,
        searchTerm,
      });
    },
    statusFilterChange: (status) => {
      Mixpanel.track(`filter-change:status`, {
        message: `Asset audit status filter changed.`,
        session_id: sessionId,
        status: status,
      });
    },
    addTrancheClick: () => {
      Mixpanel.track(`click:add-tranche`, {
        message: `Clicked 'Add Tranche' button in tranches page.`,
        session_id: sessionId,
      });
    },
    editTrancheClick: (trancheId) => {
      Mixpanel.track(`click:edit-tranche`, {
        message: `Clicked 'Edit Tranche' button in tranches page.`,
        session_id: sessionId,
        trancheId: trancheId,
      });
    },
    deleteTrancheClick: (trancheId) => {
      Mixpanel.track(`click:delete-tranche`, {
        message: `Clicked 'Delete Tranche' button in tranches page.`,
        session_id: sessionId,
        trancheId: trancheId,
      });
    },
    deleteTrancheConfirmed: (trancheId) => {
      Mixpanel.track(`confirm:delete-tranche`, {
        message: `Confirmed deletion of tranche in tranches page.`,
        session_id: sessionId,
        trancheId: trancheId,
      });
    },
    trancheFormSubmitted: (trancheId, isEdit) => {
      Mixpanel.track(`form-submit:tranche`, {
        message: isEdit
          ? `Form submitted for edit tranche in tranches page.`
          : `Form submitted for add tranche in tranches page.`,
        session_id: sessionId,
        trancheId: trancheId,
      });
    },
    attachAssetRowToTranches: (assetId, trancheId) => {
      Mixpanel.track(`action:attach-asset-to-tranches`, {
        message: `Attached asset to tranches in tranches page.`,
        session_id: sessionId,
        assetId: assetId,
        trancheId: trancheId,
      });
    },
    trancheDocumentFileClick: (trancheId) => {
      Mixpanel.track(`click:tranche-document-file`, {
        message: `Clicked on tranche document file in tranches page.`,
        session_id: sessionId,
        trancheId: trancheId,
      });
    },
    tranchePullFromBOSClick: (trancheId) => {
      Mixpanel.track(`click:tranche-pull-from-bos`, {
        message: `Clicked 'Pull from BOS' button in tranche documents modal.`,
        session_id: sessionId,
        trancheId: trancheId,
      });
    },
    trancheApiAddSubmit: () => {
      Mixpanel.track(`form-submit:tranche-api-add`, {
        message: `Form submitted for adding tranche API in tranches page.`,
        session_id: sessionId,
      });
    },
    trancheApiEditSubmit: (apiId) => {
      Mixpanel.track(`form-submit:tranche-api-edit`, {
        message: `Form submitted for editing tranche API in tranches page.`,
        session_id: sessionId,
        apiId: apiId,
      });
    },
    trancheApiEditClick: (apiName) => {
      Mixpanel.track(`click:tranche-api-edit`, {
        message: `Clicked 'Edit API' button in tranches page.`,
        session_id: sessionId,
        apiName: apiName,
      });
    },
    trancheApiDeleteClick: (apiId) => {
      Mixpanel.track(`click:tranche-api-delete`, {
        message: `Clicked 'Delete API' button in tranches page.`,
        session_id: sessionId,
        apiId: apiId,
      });
    },
    trancheApiDeleteConfirm: (apiId) => {
      Mixpanel.track(`confirm:tranche-api-delete`, {
        message: `Confirmed deletion of API in tranches page.`,
        session_id: sessionId,
        apiId: apiId,
      });
    },
    trancheDocuments: {
      viewIssueFileClick: (trancheId, colId) => {
        Mixpanel.track("click:view-issue-file", {
          message: "Opened 'Issue File' modal for tranche document.",
          session_id: sessionId,
          trancheId,
          colId,
        });
      },

      copyIssueFileLinkClick: (trancheId, colId) => {
        Mixpanel.track("click:copy-issue-file-link", {
          message: "Copied issue file URL from Issue File modal.",
          session_id: sessionId,
          trancheId,
          colId,
        });
      },

      viewTrancheHistoryClick: (trancheId, colId) => {
        Mixpanel.track("click:view-tranche-history", {
          message: "Clicked 'View History' in tranche documents modal.",
          session_id: sessionId,
          trancheId,
          colId,
        });
      },

      downloadTrancheFileClick: (trancheId, colId) => {
        Mixpanel.track("click:download-tranche-file", {
          message: "Clicked 'Download File' in tranche documents modal.",
          session_id: sessionId,
          trancheId,
          colId,
        });
      },

      confirmDownloadFileClick: (trancheId, colId) => {
        Mixpanel.track("click:confirm-download-file", {
          message:
            "Clicked 'Confirm Download' button in confirmation modal on tranche documents modal.",
          session_id: sessionId,
          trancheId,
          colId,
        });
      },

      uploadFileClick: (trancheId, colId, hasDoc) => {
        Mixpanel.track("click:upload-file", {
          message: hasDoc
            ? "Clicked 'Replace Document' button in tranche documents modal."
            : "Clicked 'Upload Document' button in tranche documents modal.",
          session_id: sessionId,
          trancheId,
          colId,
        });
      },

      uploadFileSubmitClick: (trancheId, colId) => {
        Mixpanel.track("click:upload-file-submit", {
          message: "Clicked 'Submit' button in document upload modal.",
          session_id: sessionId,
          trancheId,
          colId,
        });
      },

      validateAiClick: (trancheId, colId) => {
        Mixpanel.track("click:validate-ai", {
          message:
            "Clicked 'AI Validated' checkbox in tranche documents modal.",
          session_id: sessionId,
          trancheId,
          colId,
        });
      },

      validateManualClick: (trancheId, colId) => {
        Mixpanel.track("click:validate-manual", {
          message:
            "Clicked 'Manual Validated' checkbox in tranche documents modal.",
          session_id: sessionId,
          trancheId,
          colId,
        });
      },

      confirmValidationClick: (trancheId, colId, type) => {
        Mixpanel.track("click:confirm-validation", {
          message: `Clicked 'Confirm ${type}' validation in tranche documents modal.`,
          session_id: sessionId,
          trancheId,
          colId,
          validationType: type,
        });
      },

      trancheHistory(assetId) {
        Mixpanel.track("view:tranche-history", {
          message: "Viewed tranche document history modal.",
          session_id: sessionId,
          assetId,
        });
      },
    },
  },
  reports: {
    pageView: () => {
      Mixpanel.track("page:reports", {
        message: "Visited 'Reports' page.",
        session_id: sessionId,
      });
    },
    userSelectClick: (user) => {
      Mixpanel.track("click:reports-user-select", {
        message: "Selected a user from 'User' dropdown on 'Reports' page.",
        session_id: sessionId,
        userId: user?.id || null,
        userName: user?.label || null,
      });
    },

    userClearClick: () => {
      Mixpanel.track("click:reports-user-clear", {
        message:
          "Cleared the selected user in 'User' dropdown on 'Reports' page.",
        session_id: sessionId,
      });
    },

    modelChangeClick: (modelValue) => {
      Mixpanel.track("click:reports-model-filter", {
        message: `Changed 'Model' filter to '${modelValue}' on 'Reports' page.`,
        session_id: sessionId,
        model: modelValue,
      });
    },

    downloadReportClick: (id) => {
      Mixpanel.track("click:reports-download-report", {
        message: `Clicked 'Download Report' button for id'${id}' report on 'Reports' page.`,
        session_id: sessionId,
        reportId: id,
      });
    },
  },
  projectInput: {
    pageView: () => {
      Mixpanel.track("page:project-input", {
        message: "Visited 'Project Input' page.",
        session_id: sessionId,
      });
    },
    searchList: (searchTerm) => {
      Mixpanel.track("search:project-input-list", {
        message: "Searched the list on 'Project Input' page.",
        session_id: sessionId,
        searchTerm,
      });
    },
  },
  entityTable: {
    pageView: () => {
      Mixpanel.track("page:entity-table", {
        message: "Visited 'Entity Table' page.",
        session_id: sessionId,
      });
    },

    clickAddZohoId: () => {
      Mixpanel.track("click:entity-table-add-zoho-id", {
        message: "Clicked 'ADD' button to add Zoho ID in Entity Table.",
        session_id: sessionId,
      });
    },

    clickRowOpenPopup: (zohoId) => {
      Mixpanel.track("click:entity-table-open-details-popup", {
        message: "Opened Entity Details popup.",
        zohoCustomerId: zohoId,
        session_id: sessionId,
      });
    },

    clickReplyButton: (zohoId) => {
      Mixpanel.track("click:entity-table-reply-button", {
        message: "Clicked 'Reply' button for rejected entity.",
        zohoCustomerId: zohoId,
        session_id: sessionId,
      });
    },

    clickDownloadAttachment: (zohoId, fileId) => {
      Mixpanel.track("click:entity-table-download-attachment", {
        message: "Clicked to download Driver Licence.",
        zohoCustomerId: zohoId,
        fileId,
        session_id: sessionId,
      });
    },

    changeStatus: (status, zohoId) => {
      Mixpanel.track("click:entity-table-status-change", {
        message: "Changed entity status from dropdown.",
        newStatus: status,
        zohoCustomerId: zohoId,
        session_id: sessionId,
      });
    },

    clickRemoveAllowUser: (zohoId) => {
      Mixpanel.track("click:entity-table-remove-allow-list-user", {
        message: "Clicked 'Remove' to delete user from allow list.",
        zohoCustomerId: zohoId,
        session_id: sessionId,
      });
    },

    zohoIdSearch: (searchTerm) => {
      Mixpanel.track("search:entity-table-zoho-id", {
        message: "Searched Zoho ID in Entity Table.",
        searchTerm,
        session_id: sessionId,
      });
    },
  },
  proformaBackend: {
    pageView: () => {
      Mixpanel.track("page:proforma-backend", {
        message: "Visited 'Proforma Backend' page.",
        session_id: sessionId,
      });
    },
    clickModelChange: (modelName) => {
      Mixpanel.track("click:proforma-backend-model-change", {
        message: "Changed model from dropdown on 'Proforma Backend' page.",
        model: modelName,
        session_id: sessionId,
      });
    },

    clickUploadStateMatrix: () => {
      Mixpanel.track("click:proforma-backend-upload-state-matrix", {
        message: "Clicked 'Upload' button for State Matrix file.",
        session_id: sessionId,
      });
    },

    clickDownloadStateMatrix: () => {
      Mixpanel.track("click:proforma-backend-download-state-matrix", {
        message: "Clicked 'Download' button for State Matrix file.",
        session_id: sessionId,
      });
    },

    updateClick: (modelName) => {
      Mixpanel.track("click:update-proforma-backend", {
        message: `Clicked Update button for ${modelName}.`,
        modelName,
        session_id: sessionId,
      });
    },

    toggleLossLimitation: (newStatus, modelName) => {
      Mixpanel.track("toggle:loss-limitation", {
        message: `Toggled Loss Limitation to ${
          newStatus ? "ON" : "OFF"
        } for ${modelName}.`,
        newStatus,
        modelName,
        session_id: sessionId,
      });
    },

    toggleFederalRevenueSpread: (newStatus, modelName) => {
      Mixpanel.track("toggle:federal-revenue-spread", {
        message: `Toggled Federal Revenue Spread to ${
          newStatus ? "ON" : "OFF"
        } for ${modelName}.`,
        newStatus,
        modelName,
        session_id: sessionId,
      });
    },

    clickUpdateProformaBackend: (modelName) => {
      Mixpanel.track("click:update-proforma-backend", {
        message: `Clicked 'Update' button for ${modelName} on 'Proforma Backend' page.`,
        modelName,
        session_id: sessionId,
      });
    },
  },
  newReports: {
    pageView: () => {
      Mixpanel.track("page:new-reports", {
        message: "Visited 'New Reports' page.",
        session_id: sessionId,
      });
    },
    // Dropdown Component
    searchUser: () => {
      Mixpanel.track("click:new-reports-search-user", {
        message:
          "Searched a user in 'Select User' dropdown on New Reports page.",
        session_id: sessionId,
      });
    },

    selectUser: (userId, clientId) => {
      Mixpanel.track("click:new-reports-select-user", {
        message:
          "Selected a user in 'Select User' dropdown on New Reports page.",
        session_id: sessionId,
        userId,
        clientId,
      });
    },

    nextFromDropdown: () => {
      Mixpanel.track("click:new-reports-dropdown-next", {
        message: "Clicked 'Next' button after selecting a user.",
        session_id: sessionId,
      });
    },

    // UserIdForm Component
    enterClientId: () => {
      Mixpanel.track("click:new-reports-enter-client-id", {
        message: "Entered Client ID in New Reports page.",
        session_id: sessionId,
      });
    },

    nextFromClientId: (clientId) => {
      Mixpanel.track("click:new-reports-client-id-next", {
        message: "Clicked 'Next' button after entering Client ID.",
        session_id: sessionId,
        clientId,
      });
    },

    backFromClientId: () => {
      Mixpanel.track("click:new-reports-client-id-back", {
        message: "Clicked 'Back' button on Client ID step.",
        session_id: sessionId,
      });
    },

    // ReportForm Component
    submitReport: () => {
      Mixpanel.track("click:new-reports-submit", {
        message: "Clicked 'Next' (submit report) on Report Form.",
        session_id: sessionId,
      });
    },

    backFromReportForm: () => {
      Mixpanel.track("click:new-reports-report-form-back", {
        message: "Clicked 'Back' on Report Form.",
        session_id: sessionId,
      });
    },

    selectState: (stateId) => {
      Mixpanel.track("click:new-reports-select-state", {
        message: "Selected a state in Report Form on New Reports page.",
        session_id: sessionId,
        stateId,
      });
    },
  },
  ndaForm: {
    pageView: () => {
      Mixpanel.track("page:nda-form", {
        message: "Visited 'NDA Form' page.",
        session_id: sessionId,
      });
    },
    submitNdaForm: () => {
      Mixpanel.track("click:nda-form-submit", {
        message: "Submitted the NDA form on 'NDA Form' page.",
        session_id: sessionId,
      });
    },
    clearNdaForm: () => {
      Mixpanel.track("click:nda-form-clear", {
        message: "Cleared the NDA form on 'NDA Form' page.",
        session_id: sessionId,
      });
    },
  },
  proformaUser: {
    pageView: () => {
      Mixpanel.track("page:proforma-users", {
        message: "Visited 'Proforma Users' page.",
        session_id: sessionId,
      });
    },
    // Create User Form
    clickCreateUserSubmit: () =>
      Mixpanel.track("click:proforma-user-create-submit", {
        message: "Clicked 'Submit' button in Create Pro Forma User form.",
        session_id: sessionId,
      }),

    clickDesignationChange: (selected) =>
      Mixpanel.track("click:proforma-user-designation-change", {
        message: "Changed 'Designation' dropdown.",
        session_id: sessionId,
        designation: selected,
      }),

    clickContactGroupChange: (value) =>
      Mixpanel.track("click:proforma-user-contact-group-change", {
        message: "Changed 'Contact Group' dropdown.",
        session_id: sessionId,
        contactGroup: value,
      }),

    // Baseline Values
    clickBaselineValuesSubmit: () =>
      Mixpanel.track("click:proforma-user-baseline-values-submit", {
        message: "Clicked 'Submit' in Baseline Pro Forma Values form.",
        session_id: sessionId,
      }),

    // Contact Group Form
    clickContactGroupSubmit: () =>
      Mixpanel.track("click:contact-group-create-submit", {
        message: "Clicked 'Submit' in Contact Group creation form.",
        session_id: sessionId,
      }),

    clickJvAllowChange: () =>
      Mixpanel.track("click:contact-group-jv-allow-change", {
        message: "Changed 'Allow JV Tranche' dropdown.",
        session_id: sessionId,
      }),

    clickLowScenarioChange: () =>
      Mixpanel.track("click:contact-group-low-scenario-change", {
        message: "Changed 'Low Scenario %' dropdown.",
        session_id: sessionId,
      }),

    clickLowMidScenarioChange: () =>
      Mixpanel.track("click:contact-group-low-mid-scenario-change", {
        message: "Changed 'Low-Mid Scenario %' dropdown.",
        session_id: sessionId,
      }),

    clickHighMidScenarioChange: () =>
      Mixpanel.track("click:contact-group-high-mid-scenario-change", {
        message: "Changed 'High-Mid Scenario %' dropdown.",
        session_id: sessionId,
      }),

    clickHighScenarioChange: () =>
      Mixpanel.track("click:contact-group-high-scenario-change", {
        message: "Changed 'High Scenario %' dropdown.",
        session_id: sessionId,
      }),

    // Table Actions
    clickUserEdit: (name) =>
      Mixpanel.track("click:proforma-user-edit", {
        message: "Clicked 'Edit' on Pro Forma User.",
        session_id: sessionId,
        name: name,
      }),

    clickUserEditSubmit: (name) =>
      Mixpanel.track("click:proforma-user-edit-submit", {
        message: "Clicked 'Submit' in Edit Pro Forma User form.",
        name: name,
        session_id: sessionId,
      }),

    clickUserDelete: (id) =>
      Mixpanel.track("click:proforma-user-delete", {
        message: "Clicked 'Delete' on Pro Forma User.",
        user_id: id,
        session_id: sessionId,
      }),

    clickContactGroupEdit: (name) =>
      Mixpanel.track("click:contact-group-edit", {
        message: "Clicked 'Edit' on Contact Group.",
        group_name: name,
        session_id: sessionId,
      }),

    clickContactGroupDelete: (name) =>
      Mixpanel.track("click:contact-group-delete", {
        message: "Clicked 'Delete' on Contact Group.",
        group_name: name,
        session_id: sessionId,
      }),

    clickContactGroupUpdateSubmit: (name) =>
      Mixpanel.track("click:contact-group-update-submit", {
        message: "Clicked Update Contact Group form submit.",
        session_id: sessionId,
        group_name: name,
      }),

    // Toggle: Allow 20% Markup
    clickToggleTwentyPercent: (value) =>
      Mixpanel.track("click:contact-group-allow-20-toggle", {
        message: "Changed Allow 20% Markup toggle.",
        session_id: sessionId,
        value,
      }),

    // Toggle: JV Tranche Allowed
    clickToggleJvPurchaser: (value) =>
      Mixpanel.track("click:contact-group-jv-tranche-toggle", {
        message: "Changed JV Tranche Allowed toggle.",
        session_id: sessionId,
        value,
      }),

    // Dropdown: Scenario Changes
    clickScenarioLowChange: (value) =>
      Mixpanel.track("click:contact-group-low-scenario-change", {
        message: "Changed Low Scenario %",
        session_id: sessionId,
        value,
      }),

    clickScenarioLowMidChange: (value) =>
      Mixpanel.track("click:contact-group-lowmid-scenario-change", {
        message: "Changed Low-Mid Scenario %",
        session_id: sessionId,
        value,
      }),

    clickScenarioHighMidChange: (value) =>
      Mixpanel.track("click:contact-group-highmid-scenario-change", {
        message: "Changed High-Mid Scenario %",
        session_id: sessionId,
        value,
      }),

    clickScenarioHighChange: (value) =>
      Mixpanel.track("click:contact-group-high-scenario-change", {
        message: "Changed High Scenario %",
        session_id: sessionId,
        value,
      }),

    // Dropdown: Additional Contact Groups
    clickAdditionalCGChange: (values) =>
      Mixpanel.track("click:contact-group-additional-groups-change", {
        message: "Changed Additional Contact Groups.",
        session_id: sessionId,
        values,
      }),

    // Dropdown: Selected Model
    clickModelChange: (value) =>
      Mixpanel.track("click:contact-group-model-change", {
        message: "Changed Selected Model.",
        session_id: sessionId,
        value: value,
      }),

    // Email add
    clickAddEmailSubmit: (email) =>
      Mixpanel.track("click:contact-group-add-email-submit", {
        message: "Submitted email add form.",
        session_id: sessionId,
        email,
      }),

    // Email delete
    clickDeleteEmail: (email) =>
      Mixpanel.track("click:contact-group-delete-email", {
        message: "Clicked delete email chip.",
        session_id: sessionId,
        email,
      }),
  },
  proformaGeneration: {
    pageView: () => {
      Mixpanel.track("page:proforma-generation", {
        message: "Visited 'Proforma Generation' page.",
        session_id: sessionId,
      });
    },
    generateProformaClick: () => {
      Mixpanel.track("click:generate-proforma", {
        message: `Clicked 'Generate Proforma' button on Proforma Generation.`,
        session_id: sessionId,
      });
    },
    submitProformaClick: () => {
      Mixpanel.track("click:submit-proforma", {
        message: `Clicked 'Submit Proforma' button on Proforma Generation.`,
        session_id: sessionId,
      });
    },
    proformaSearch: (searchTerm) => {
      Mixpanel.track("search:proforma-generation", {
        message: "Searched the list on 'Proforma Generation' page.",
        session_id: sessionId,
        searchTerm,
      });
    },
  },
  contactOwner: {
    pageView: () => {
      Mixpanel.track("page:contact-owner", {
        message: "Visited 'Contact Owner' page.",
        session_id: sessionId,
      });
    },
    submitContactOwnerClick: () => {
      Mixpanel.track("click:submit-contact-owner", {
        message: `Clicked 'Submit' button on Contact Owner page.`,
        session_id: sessionId,
      });
    },
    editContactOwnerClick: () => {
      Mixpanel.track("click:edit-contact-owner", {
        message: `Clicked 'Edit' button on Contact Owner page.`,
        session_id: sessionId,
      });
    },
    submitEditContactOwnerClick: () => {
      Mixpanel.track("click:submit-edit-contact-owner", {
        message: `Clicked 'Submit' button on Edit Contact Owner form.`,
        session_id: sessionId,
      });
    },
    deleteContactOwnerClick: () => {
      Mixpanel.track("click:delete-contact-owner", {
        message: `Clicked 'Delete' button on Contact Owner page.`,
        session_id: sessionId,
      });
    },
  },
  tsaManagement: {
    pageView: () => {
      Mixpanel.track("page:tsa-management", {
        message: "Visited 'TSA Management' page.",
        session_id: sessionId,
      });
    },
    deleteTsaMamaClick: () => {
      Mixpanel.track("click:delete-tsa-mama", {
        message: `Clicked 'Delete TSA MAMA' button on TSA Management page.`,
        session_id: sessionId,
      });
    },
    tsaManagementSearch: (searchTerm) => {
      Mixpanel.track("search:tsa-management", {
        message: "Searched the list on 'TSA Management' page.",
        session_id: sessionId,
        searchTerm,
      });
    },
    addTsaClick: () => {
      Mixpanel.track("click:add-tsa", {
        message: `Clicked 'Add TSA' button on TSA Management page.`,
        session_id: sessionId,
      });
    },
    addCondition: () => {
      Mixpanel.track("click:add-condition", {
        message: "Clicked 'Add Condition' button in Create TSA modal.",
        session_id: sessionId,
      });
    },

    removeCondition: (index) => {
      Mixpanel.track("click:remove-condition", {
        message: `Clicked 'Remove Condition' button at index ${index} in Create TSA modal.`,
        removedIndex: index,
        session_id: sessionId,
      });
    },

    selectContactGroupType: (value) => {
      Mixpanel.track("click:select-contact-group-type", {
        message: "Selected Contact Group Type in Create TSA modal.",
        selectedValue: value,
        session_id: sessionId,
      });
    },

    clickCancel: () => {
      Mixpanel.track("click:cancel-create-tsa", {
        message: "Clicked 'Cancel' button in Create TSA modal.",
        session_id: sessionId,
      });
    },

    clickCreateTsa: () => {
      Mixpanel.track("click:create-tsa-type", {
        message: "Clicked 'Create TSA Type' button in Create TSA modal.",
        session_id: sessionId,
      });
    },

    viewTsaType: () => {
      Mixpanel.track("click:view-tsa-type", {
        message: "Clicked 'View TSA Type' link in Create TSA modal.",
        session_id: sessionId,
      });
    },

    editTsaType: () => {
      Mixpanel.track("click:edit-tsa-type", {
        message: "Clicked 'Edit TSA Type' link in Create TSA modal.",
        session_id: sessionId,
      });
    },

    updateTsaType: () => {
      Mixpanel.track("click:update-tsa-type", {
        message: "Clicked 'Update TSA Type' button in Edit TSA modal.",
        session_id: sessionId,
      });
    },
  },
  trancheBotV2: {
    pageView: () => {
      Mixpanel.track("page:tranche-bot-v2", {
        message: "Visited 'Tranche Bot V2' page.",
        session_id: sessionId,
      });
    },
    advancedFilter: () => {
      Mixpanel.track("filter-click:tranche-bot-v2-advanced-filter", {
        message: `click advanced filter on 'Tranche Bot V2' page.`,
        session_id: sessionId,
      });
    },
    refetchOpportunities: () => {
      Mixpanel.track("click:tranche-bot-v2-refetch-opportunities", {
        message: `Clicked 'Refetch Opportunities' button on 'Tranche Bot V2' page.`,
        session_id: sessionId,
      });
    },
    findAssetTrancheBotV2: () => {
      Mixpanel.track("click:tranche-bot-v2-find-asset", {
        message: `Clicked 'Find Asset' button on 'Tranche Bot V2' page.`,
        session_id: sessionId,
      });
    },
    analyticsClick: () => {
      Mixpanel.track("click:tranche-bot-v2-analytics", {
        message: `Clicked 'Analytics' button on 'Tranche Bot V2' page.`,
        session_id: sessionId,
      });
    },
    createTrancheClick: () => {
      Mixpanel.track("click:tranche-bot-v2-create-tranche", {
        message: `Clicked 'Create Tranche' button on 'Tranche Bot V2' page.`,
        session_id: sessionId,
      });
    },
    cancelTrancheClick: () => {
      Mixpanel.track("click:tranche-bot-v2-cancel-tranche", {
        message: `Clicked 'Cancel' button on 'Create Tranche' modal on 'Tranche Bot V2' page.`,
        session_id: sessionId,
      });
    },
    sendTrancheApproval: () => {
      Mixpanel.track("click:tranche-bot-v2-send-tranche-approval", {
        message: `Clicked 'Send for Approval' button on 'Create Tranche' modal on 'Tranche Bot V2' page.`,
        session_id: sessionId,
      });
    },
    trancheClick: (id) => {
      Mixpanel.track("click:tranche-bot-v2-tranche", {
        message: `Clicked on a tranche row on 'Tranche Bot V2' page.`,
        session_id: sessionId,
        trancheId: id,
      });
    },
  },
  assets: {
    pageView: () => {
      Mixpanel.track("page:assets", {
        message: "Visited 'Assets' page.",
        session_id: sessionId,
      });
    },
    handleExportAssetsClick: () => {
      Mixpanel.track("click:export-assets", {
        message: "Clicked 'Export Assets' button on 'Assets' page.",
        session_id: sessionId,
      });
    },
    handleUploadAssetsClick: () => {
      Mixpanel.track("click:upload-assets", {
        message: "Clicked 'Upload Assets' button on 'Assets' page.",
        session_id: sessionId,
      });
    },
  },
  divisorLookUp: {
    pageView: () =>
      Mixpanel.track("pageview:divisor-lookup", {
        message: "Visited Divisor Lookup page",
      }),

    // ---- SEARCH ----
    searchChange: (value) =>
      Mixpanel.track("change:divisor-search", {
        message: "Updated search input on Divisor Lookup page",
        search_value: value,
      }),

    // ---- CREATE ----
    openCreateModal: () =>
      Mixpanel.track("click:divisor-open-create-modal", {
        message: "Opened Create Divisor Lookup modal",
      }),

    createSubmit: () =>
      Mixpanel.track("submit:divisor-create", {
        message: "Submitted create divisor lookup form",
      }),

    // ---- EDIT ----
    openEditModal: (id) =>
      Mixpanel.track("click:divisor-open-edit-modal", {
        message: "Opened Edit Divisor Lookup modal",
        record_id: id,
      }),

    editSubmit: (id) =>
      Mixpanel.track("submit:divisor-edit", {
        message: "Submitted edit divisor lookup form",
        record_id: id,
      }),

    // ---- DELETE ----
    openDeleteModal: (id) =>
      Mixpanel.track("click:divisor-open-delete-modal", {
        message: "Opened delete confirmation modal",
        record_id: id,
      }),

    confirmDelete: (id) =>
      Mixpanel.track("click:divisor-confirm-delete", {
        message: "Confirmed record delete",
        record_id: id,
      }),

    toggleFeatureFlag: (enabled) =>
      Mixpanel.track("toggle:divisor-feature-flag", {
        message: "Toggled divisor lookup feature flag",
        enabled: enabled,
      }),
  },
  unArchivedModule: {
    unArchivedModuleClick: (name) => {
      Mixpanel.track("click:unarchived-module", {
        message: "Clicked 'Unarchived Modules' button on 'Assets v2' page.",
        session_id: sessionId,
        name,
      });
    },
  },
  productionReportUploadLogs: {
    pageView: () => {
      Mixpanel.track("page:production-report-upload-logs", {
        message: "Visited 'Production Report Upload Logs' page.",
        session_id: sessionId,
      });
    },
    uploadedFileClick: (key) => {
      Mixpanel.track("click:production-report-upload-logs-uploaded-file", {
        message:
          "Clicked 'Uploaded File' button in production report upload logs.",
        session_id: sessionId,
        key: key,
      });
    },
    errorFileClick: (key) => {
      Mixpanel.track("click:production-report-error-logs-uploaded-file", {
        message:
          "Clicked 'Error Report' button in production report upload logs.",
        session_id: sessionId,
        key: key,
      });
    },
  },
};
